export const RoleTypes = Object.freeze({
  Post: 'POST',
  Company: 'COMPANY',
  Information: 'INFORMATION',
  Category: 'CATEGORY',
});

export const AdminRolesTypes = Object.freeze({
  Category: 'CATEGORY',
  Reader: 'READER',
  Partner: 'PARTNER',
  Company: 'COMPANY',
  Admin: 'ADMIN',
  Import: 'IMPORT',
});

export const AdminRolesFolders = Object.freeze({
  CATEGORY: [
    'YEAR',
    'LOCATION',
    'MATERIAL',
    'COLOUR',
    'DESIGNER',
    'GROUP',
    'SINCE',
    'LANGUAGE',
  ],
  READER: ['LIST', 'STATICS'],
  PARTNER: ['PARTNER', 'LIST', 'COMPETITION'],
  ADMIN: ['TEAM', 'ROLE', 'SITEMAP', 'SETTINGS'],
  COMPANY: ['PROFILE', 'ABOUT', 'PARTNER', 'CLOUD'],
  IMPORT: ['PROFILE', 'POSTS', 'CATEGORIES'],
});
